module.exports = __webpack_public_path__ + "static/tcl-f00ddfe9a435f5dd922c59a2d6c665e5.png";